import React, { useState } from 'react';
import { Facebook, Linkedin, Twitter, MessageCircle, Link2, Check } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const SITE = 'https://www.party-led.com';

export const ShareButtons = ({ path, title }) => {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);
  const url = `${SITE}${path}`;
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const targets = [
    { key: 'whatsapp', icon: MessageCircle, label: 'WhatsApp', href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`, color: 'hover:text-[#25D366] hover:border-[#25D366]/40' },
    { key: 'facebook', icon: Facebook, label: 'Facebook', href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, color: 'hover:text-[#1877F2] hover:border-[#1877F2]/40' },
    { key: 'x', icon: Twitter, label: 'X', href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`, color: 'hover:text-white hover:border-white/40' },
    { key: 'linkedin', icon: Linkedin, label: 'LinkedIn', href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`, color: 'hover:text-[#0A66C2] hover:border-[#0A66C2]/40' },
  ];

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (e) {
      setCopied(false);
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
      <span className="text-xs uppercase tracking-widest text-gray-500 mr-1">{t.share.label}</span>
      {targets.map(({ key, icon: Icon, label, href, color }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          className={`w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 transition-colors duration-200 ${color}`}
          data-testid={`share-${key}`}
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
      <button
        onClick={handleCopy}
        aria-label={t.share.copy}
        title={t.share.copy}
        className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-purple-400 hover:border-purple-500/40 transition-colors duration-200"
        data-testid="share-copy"
      >
        {copied ? <Check className="w-4 h-4 text-green-400" /> : <Link2 className="w-4 h-4" />}
      </button>
      {copied && <span className="text-xs text-green-400" data-testid="share-copied">{t.share.copied}</span>}
    </div>
  );
};

export default ShareButtons;
